import * as React from 'react'
import styled from '@theme/styled-components'

import { HiOutlineChevronLeft, HiOutlineChevronRight } from 'react-icons/hi'
import { generatePagination } from '@utils/PaginationUtils'
import Theme from '@theme/Theme'

interface Props {
  currentPage: number
  setCurrentPage: (page: number) => void
  numberBusinesses: number
}

const PaginationComponent = ({ currentPage, setCurrentPage, numberBusinesses }: Props) => {
  const pageTotal = Math.floor(numberBusinesses / 50 + 1)
  const pages = generatePagination(currentPage, pageTotal)

  return (
    <MainContainer>
      {pageTotal > 1 && (
        <NumbersContainer>
          <PageNavigation>
            {currentPage > 1 && (
              <ChevronBox onClick={() => setCurrentPage(currentPage - 1)} isLeft>
                <HiOutlineChevronLeft size={20} color={Theme.colors.primary_blue} />
              </ChevronBox>
            )}
            {pages.map((page, index) => {
              return !!page ? (
                <NumberBox
                  key={`${page} - ${index}`}
                  onClick={() => setCurrentPage(page)}
                  isSelected={page === currentPage}
                  isThreeDot={false}>
                  <Number isSelected={page === currentPage}>{page}</Number>
                </NumberBox>
              ) : (
                <NumberBox key={`${page} - ${index}`} isSelected={false} isThreeDot>
                  <Number isSelected={false}>...</Number>
                </NumberBox>
              )
            })}
            {currentPage < pageTotal && (
              <ChevronBox onClick={() => setCurrentPage(currentPage + 1)} isLeft={false}>
                <HiOutlineChevronRight size={20} color={Theme.colors.primary_blue} />
              </ChevronBox>
            )}
          </PageNavigation>
        </NumbersContainer>
      )}
    </MainContainer>
  )
}
export default PaginationComponent

const MainContainer = styled('div')`
  padding: 0.75em 0.5em;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-top: 1px solid ${(props) => props.theme.colors.greyBorder};
`
const NumbersContainer = styled('div')``
const PageNavigation = styled('nav')`
  position: relative;
  display: inline-flex;
  border-radius: 6px;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
`
const ChevronBox = styled('div')<{ isLeft: boolean }>`
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 0.5em;
  cursor: pointer;
  border: 1px solid;
  border-radius: ${(props) => (props.isLeft ? '6px 0px 0px 6px' : '0px 6px 6px 0px')};
  border-color: ${(props) => props.theme.colors.greyBorder};
`
const NumberBox = styled('div')<{ isSelected: boolean; isThreeDot: boolean }>`
  position: relative;
  align-items: center;
  padding: 0.5em 1em;
  ${(props) => !props.isThreeDot && 'cursor: pointer'};
  background-color: ${(props) => props.isSelected && props.theme.colors.light_primary_blue};
  border: 1px solid ${(props) => (props.isSelected ? props.theme.colors.primary_blue : props.theme.colors.greyBorder)};
`
const Number = styled('p')<{ isSelected: boolean }>`
  ${(props) => props.theme.fonts.pagination};
  color: ${(props) => props.isSelected && props.theme.colors.primary_blue};
  margin: 0px;
`
